module.exports = __webpack_public_path__ + "static/media/TECHNOLOGY-ICON.70b02bac.svg";